import React from 'react';
import Header_gamebox from '../Components/Header_gamebox';

const HowToPlay = () => {
  return (
    <>
    <Header_gamebox/>
    <div class="flex justify-center items-center lg:h-[80vh] " >
    <div class="border-4 border-solid border-black w-full sm:w-3/4 md:w-1/2 lg:w-[700px] p-4 sm:p-6 " >
    <h1 class="text-3xl font-bold mb-4 text-center">How To Play</h1>
    <div class="font-bold text-md sm:text-base text-justify text-left" >
    1. Subscribe by sending an SMS with "GB" for daily @N150 or "GB7" for weekly @N200 to 13276.
    <br/>
    {/* 2. Get 10 points automatically upon subscription and renewal every day.
    <br/> */}
    {/* 3. Ensure entries are submitted before 6 pm daily to qualify for the draw..
    <br/> */}
    {/* 4. Ensure entries are submitted before 6 pm daily to qualify for the draw. */}
    2. To unsubscribe send STOP GB or STOP GB7

    <br/>
    {/* 5. To unsubscribe send stop GB or Stop GB7 */}

    </div>
   

    </div>
    </div>
    </>
  );
}

export default HowToPlay;
